import type { ConstValues } from '@openx/types/helpers';

import type { JSX } from 'react';

export const RouterMethod = {
  internal: 'internal',
  external: 'external',
  crossApp: 'crossApp',
} as const;
export type RouterMethod = ConstValues<typeof RouterMethod>;

export const MenuColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;
export type MenuColor = ConstValues<typeof MenuColor>;

export type NavRouteConfig = {
  title: string;
  method: RouterMethod;
  path: string;
  permissionCheck: () => boolean;
  Icon?: () => JSX.Element | null;
  activePathOverride?: string;
};

export interface NavNestedRouteConfig {
  title: string;
  routes: NavRouteConfig[];
  Icon?: () => JSX.Element | null;
  permissionCheck?: () => boolean;
}
